export class SendGiftCardWidgetSettings {
  public sendGiftCardUrl: string;
}
